import { parse } from "date-fns";

type CompareDateListItem = {
  date: string;
  time: string;
};

export const compareDateTime = (
  a: CompareDateListItem,
  b: CompareDateListItem
) => {
  const aDateTime = parse(
    `${a.date} ${a.time}`,
    "yyyy-MM-dd HH:mm:ss",
    new Date()
  );

  const bDateTime = parse(
    `${b.date} ${b.time}`,
    "yyyy-MM-dd HH:mm:ss",
    new Date()
  );

  if (aDateTime < bDateTime) {
    return -1;
  }
  if (aDateTime > bDateTime) {
    return 1;
  }
  return 0;
};
